const mintABITemplate = {
    constant: false,
    inputs: [
        {
            name: "_amount",
            type: "uint256",
        },
        {
            name: "_nHash",
            type: "bytes32",
        },
        {
            name: "_sig",
            type: "bytes",
        },
    ],
    outputs: [],
    payable: true,
    stateMutability: "payable",
    type: "function",
};
// tslint:disable-next-line: no-any
const fixTuple = (argument) => {
    const { value, ...args } = argument;
    try {
        // If type is `tuple(...)` but components haven't been
        // been passed in, add them.
        const match = args &&
            args.type &&
            args.type.match(/tuple\(([a-zA-Z0-9]+)(?:,([a-zA-Z0-9]+))*\)/);
        if (match && !argument.components) {
            const types = match.slice(1);
            const components = [];
            for (let i = 0; i < types.length; i++) {
                components[i] = {
                    name: String(i),
                    type: types[i],
                };
            }
            return {
                ...args,
                components,
            };
        }
    }
    catch (error) {
        console.error(error);
    }
    return args;
};
export const payloadToABI = (methodName, payload) => {
    return [
        {
            name: methodName,
            type: "function",
            inputs: [...(payload || []).map(fixTuple)],
            outputs: [],
        },
    ];
};
export const payloadToMintABI = (methodName, payload) => {
    return [
        {
            ...mintABITemplate,
            name: methodName,
            inputs: [
                ...(payload || []).map(fixTuple),
                ...(mintABITemplate.inputs ? mintABITemplate.inputs : []),
            ],
        },
    ];
};
//# sourceMappingURL=data:application/json;base64,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